module.exports = __webpack_public_path__ + "static/media/yom-kipur.9f1f65ca.svg";